module.exports = __webpack_public_path__ + "static/media/IMG_0085.31485e4c.JPG";